import { FC } from 'react';

const Mute: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13 12C13 9.45813 12.7849 6.9701 12.373 4.55567C12.2494 3.83122 11.4028 3.51321 10.8175 3.95772L7.53627 6.44984C7.18835 6.71409 6.76348 6.85714 6.3266 6.85714H3C1.89543 6.85714 1 7.75257 1 8.85714V15.1429C1 16.2474 1.89543 17.1429 3 17.1429H6.3266C6.76348 17.1429 7.18835 17.2859 7.53627 17.5502L10.8175 20.0423C11.4027 20.4868 12.2494 20.1688 12.373 19.4443C12.7849 17.0299 13 14.5419 13 12Z"
        fill="white"
        stroke="white"
        strokeLinejoin="round"
      />
      <path
        d="M17 9L23 15M17 15L23 9"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Mute;
